import React from "react";
import update from 'immutability-helper';
import { withRouter } from "./react/WithRouter";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import Badge from 'react-bootstrap/Badge';

import RiskDetails from "./RiskDetails";
import RiskAssessment from "./RiskAssessment";
import MitigationList from "./MitigationList";
import RiskHistory from "./RiskHistory";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";


class Risk extends React.Component {
	
	state = {
		risk: {
			riskID: 0,
			name: '',
			process: '',
			category: 1,
			owner: 0,
			description: '',
			rootCause: '',
			potentialConsequence: '',
			consequence: 1,
			probability: 1,
			riskHistory:[],
		},
		saving: false,
		modified: false,
		riskAfter: {probabilityAfter: 1, consequenceAfter: 1},
		mitigationWarning: '',
		isLoadingData: false,
	};


	componentDidMount() {
		this.fetchRiskDetails(this.props.params.riskID);
	}

	componentDidUpdate(prevProps, prevState) {

	}


	fetchRiskDetails(id) {
		this.setState({ isLoadingData: true });
		fetch('api/Risk/GetRiskDetails/' + id, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then((response) => {
			return response.json();
		})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}

				for (var i = 0; i < data.risk.riskHistory.length; i++) {
					data.risk.riskHistory[i].date = new Date(data.risk.riskHistory[i].date);
				}

				this.setState({ categoryList: data.categoryList });
				this.setState({ processList: data.processList });
				this.setState({ roleList: data.roleList });

				this.setState({ risk: data.risk });

				this.setState({ isLoadingData: false });
			})
			.catch(error => {
			this.setState({ isLoadingData: false });
			})
	}

	fetchSaveRisk() {
		this.setState({ isLoadingData: true });

		fetch('api/Risk/SaveRisk', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.risk) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}

				this.setState({ isLoadingData: false });
				this.setState({ modified: false });
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
				//Gör något om fel
			})
	}

	onChange(field, value) {
		const risk = update(this.state.risk, { [field]: { $set: value } });
		this.setState({ risk: risk });
		this.setState({ modified: true });
	}

	onMitigationChanged(e) {
		this.setState({ mitigationWarning: e.warning });
		this.setState({ riskAfter: { probabilityAfter: e.lowestProbability, consequenceAfter: e.lowestConsequence, warning: e.warning } });

	}

	onAdjustRisk(e) {
		var newConsequence = Math.min(e.consequence, this.state.risk.consequence);
		var newProbability = Math.min(e.probability, this.state.risk.probability);
		const risk = update(this.state.risk, { probability: { $set: newProbability }, consequence: { $set: newConsequence } });
		this.setState({ risk: risk });
		this.setState({ modified: true });
	}


	render() {
		return (
			<Card className="workspace-card">
				<Card.Header>
					<div style={{ float: 'left' }}>
						<b>Risk details - {this.state.risk.name}</b>
						</div>
					<div style={{ float: 'right' }}>
						<Button variant="primary" color="primary" size='sm' onClick={this.fetchSaveRisk.bind(this)} disabled={!this.state.modified || this.state.saving} >
							{this.state.saving ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <div><FontAwesomeIcon icon={faCloudUploadAlt} /> &nbsp;Save</div>}
						</Button>
					</div>
				</Card.Header>
				<Card.Body style={{ padding: 0, overflow: 'hidden' }}>
					<Tabs defaultActiveKey="Details" id="risk-tab" className="mb-3" justify disabled={this.state.isLoadingData}>
						<Tab eventKey="Details" title="Details" >
							<RiskDetails
								categoryList={this.state.categoryList}
								processList={this.state.processList}
								roleList={this.state.roleList}
								risk={this.state.risk}
								onChange={this.onChange.bind(this)}
								isLoading={this.state.isLoadingData}
							/>	
						</Tab>
						<Tab eventKey="Assessment" title="Assessment">
							<RiskAssessment
								risk={this.state.risk}
								onChange={this.onChange.bind(this)}
								riskAfter={this.state.riskAfter}
							/>
						</Tab>
						<Tab eventKey="Mitigaions" title={<div>Controls & Mitigations {this.state.mitigationWarning ? < Badge pill bg="warning" text="dark">!</Badge> : null}</div>} >
							<MitigationList risk={this.state.risk} onMitigationChanged={this.onMitigationChanged.bind(this)} onAdjustRisk={this.onAdjustRisk.bind(this)} />
						</Tab>
						<Tab eventKey="History" title="History" mountOnEnter={true} unmountOnExit={true} >
							<RiskHistory risk={this.state.risk} />
						</Tab>
					</Tabs>
				</Card.Body>
				<Card.Footer>

				</Card.Footer >
			</Card >
		)
	}
}

export default withRouter(Risk);
